export default {
  name: 'Họ & tên',
  customer_name: 'Hành khách',
  phone: 'Số điện thoại',
  phone_book: 'vd: Mã quốc gia - Số điện thoại',
  address: 'Địa chỉ',
  email: 'Email',
  email_book: 'Email nhận vé',
  address_book: 'Nơi ở hiện nay',
  load_more: 'Xem thêm chuyến',
  order_by_label: 'Sắp xếp theo',
  list_title: 'Đặt mua vé xe từ {from} đi {to} vào ngày {date}',
  result_empty_title: 'Không tìm thấy chuyến đi',
  result_empty_content_1: 'Hiện chúng tôi chưa cập nhật đơn hàng online',
  result_empty_content_2: '{route} ngày {date}',
  result_empty_content_3: 'Vui lòng tìm kiếm chuyến đi có ngày khởi hành khác hoặc thay đổi lộ trình tìm kiếm.',
  note: 'Ghi chú',
  something_went_wrong: 'Something went wrong',
  something_went_wrong_content: 'Đã xảy ra lỗi không mong muốn.</br>' +
      'Xin vui lòng đợi một lát và thử lại.</br>' +
      'Nếu tình trạng này xảy ra nhiều lần, vui lòng gọi đến đường dây nóng để được hỗ trợ.',
  rebook_tickets: 'Đặt lại',
  ticket_code: 'Mã đơn hàng',
  ticket_code_placeholder: 'Nhập mã đơn hàng',
  see_ticket_info: 'Xem thông tin đơn hàng',
  phone_placeholder: 'Nhập số điện thoại đặt hàng',
  ticket_code_error: 'Vui lòng nhập mã đơn hàng',
  phone_error: 'Vui lòng nhập số điện thoại',
  ticket_info_title: 'Nhập thông tin đơn hàng',
  ticket_info_note: 'Trường hợp bạn không thể hủy đơn hàng qua mạng hoặc muốn đổi chuyến khác vui lòng liên hệ qua số điện thoại {phone}.',
  service_fee_name: 'Phí dịch vụ',
  surcharge: 'Phụ phí',
  vuilongchondulieu: 'Vui lòng chọn dữ liệu',
}
